import React from "react";
import styled, { keyframes } from "styled-components";

const load = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const StyledSpinner = styled.div`
  position: relative;
  width: ${(props) => props.size || "2.5rem"};
  height: ${(props) => props.size || "2.5rem"};
  margin: ${(props) => props.margin || "0"};

  &::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid ${(props) => props.trackColor || "#e2e8f0"};
  }

  &::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: ${(props) => props.color || "#2563eb"};
    animation: ${load} 0.6s ease infinite;
  }
`;

export const Spinner = ({ size, color, trackColor, margin, ...props }) => {
  return (
    <StyledSpinner
      size={size}
      color={color}
      trackColor={trackColor}
      margin={margin}
      {...props}
    />
  );
};

const StyledButtonSpinner = styled(StyledSpinner)`
  width: ${(props) => props.size || "1rem"};
  height: ${(props) => props.size || "1rem"};
  margin: ${(props) => props.margin || "0 0.5rem"};

  &::before {
    border-color: rgba(255, 255, 255, 0.2);
  }

  &::after {
    border-top-color: ${(props) => props.color || "#ffffff"};
  }
`;

export const ButtonSpinner = ({ size, color, margin, ...props }) => {
  return (
    <StyledButtonSpinner size={size} color={color} margin={margin} {...props} />
  );
};
